<script>
  import ClickOut from '../../../../utils/directives/clickout'
  export default{
    name: 'btn-relatorios-preparacao-leilao',
    data () {
      return {
        open: false
      }
    },
    computed: {
    },
    mounted () {},
    destroyed () {
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    directives: {ClickOut},
    components: {}
  }
</script>

<template>
  <div class="btn-group dropdown" :class="{open: open}"  v-click-out="hide">
    <button class="btn btn-sm btn-success" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle"><i class="fa fa-file-text m-r-xs"></i> Relatórios da Preparação <span class="caret"></span></button>
    <ul class="dropdown-menu no-padder">
      <li>
        <a @click="$emit('openResultadoGeracaoLotes')" tabindex="2"><i class="fa fa-book fa-fw"></i> Geração de Lotes</a>
      </li>
      <li>
        <a @click="$emit('openResultadoImportacaoCsvGrv')" tabindex="2"><i class="fa fa-book fa-fw"></i> Importação CSV de GRV</a>
      </li>
      <li>
        <a @click="$emit('openResultadoImportacaoSecundaria')" tabindex="2"><i class="fa fa-book fa-fw"></i> Importação Secundária</a>
      </li>
       <li>
        <a @click="$emit('openResultadoExportacaoDestinatarios')" tabindex="2"><i class="fa fa-book fa-fw"></i> Exportação de Destinatários - Correios</a>
      </li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// BtnRelatoriosPreparacaoLeilao.vue?a1b96a4a